import { UpgradeComponent } from '@angular/upgrade/static';
import {
    Directive,
    ElementRef,
    EventEmitter,
    Injector,
    Input,
    Output
} from '@angular/core';

@Directive({
    selector: 'network-point-search'
})
export class NetworkPointSearchComponent extends UpgradeComponent {
    @Input() public separateFavorites: boolean;
    @Input() public placeholder: string;
    @Input() public placeholderModel: any;
    @Output() public submitSelection: any;
    @Output() public onQuickfilter: '&?';
    @Input() public singleSelection: boolean;
    @Input() public preSelected: any;
    @Input() public mode: string;
    @Input() public dropdownPersist: boolean;
    @Input() public hideCheckboxes: boolean;
    @Input() public hideButtons: boolean;
    @Input() public noLeftOverflow: boolean;
    @Input() public inputAddon: string;
    @Input() public search: string;
    @Input() public filterMarketArea: any;
    @Input() public filterMarketAreaNames: any;
    @Input() public filterMarketAreaReverse: any;
    @Input() public filterTso: any;
    @Input() public filterTsoReverse: any;
    @Input() public isFilterFcfs: any;
    @Input() public detailLevel: any;
    @Input() public bundleType: any;
    @Input() public filterDirection: any;
    @Input() public filterMarket: any;
    @Input() public filterConnectionPointType: any;
    @Input() public filterFlowUnit: any;
    @Input() public alignmentMode: any;
    @Input() public allowFutureForTso: any;
    @Input() public hideCubicMeterPoints: boolean;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('networkPointSearch', elementRef, injector);
    }
}
